/**
 * `memory-box`: variables as labelled boxes in memory.
 *
 * <div class="pc-widget" data-widget="memory-box"
 *      data-cells='[{"name":"age","type":"int","value":"20","address":"0x7ffd04"}]'
 *      data-active="age" data-caption="One box, one name, one address.">
 *   <p class="pc-widget-fallback">age is an int holding 20 at 0x7ffd04.</p>
 * </div>
 */

import { asText, buildShell, el, isStringOrNumber, parseJson, type WidgetText } from "./dom";

interface Cell {
  name: string;
  type?: string;
  value: string | number;
  address?: string;
}

const isCells = (value: unknown): value is Cell[] =>
  Array.isArray(value) &&
  value.length > 0 &&
  value.every(
    (cell) =>
      typeof cell === "object" &&
      cell !== null &&
      typeof (cell as Cell).name === "string" &&
      isStringOrNumber((cell as Cell).value),
  );

export function renderMemoryBox(host: HTMLElement, text: WidgetText): boolean {
  const cells = parseJson(host.dataset.cells, isCells);
  if (!cells) return false;

  const shell = buildShell(host, {
    label: text("labelMemory"),
    caption: host.dataset.caption,
  });

  const row = el("div", "pc-widget-cells");
  for (const cell of cells) {
    const box = el("div", "pc-cell");
    if (cell.name === host.dataset.active) box.classList.add("is-active");
    box.append(el("span", "pc-cell-name", cell.type ? `${cell.type} ${cell.name}` : cell.name));
    box.append(el("span", "pc-cell-value", asText(cell.value)));
    if (cell.address) box.append(el("span", "pc-cell-meta", cell.address));
    row.append(box);
  }
  shell.body.append(row);
  return true;
}
